import React from "react";
import DatePicker from "react-datepicker";

interface DatePeriodSelectionProps {
    toDate: Date;
    fromDate: Date;
    setFromDate: (date: Date) => void;
    setToDate: (date: Date) => void;
}
function DatePeriodSelection({ toDate, fromDate, setFromDate, setToDate }: DatePeriodSelectionProps) {
    const handleFromDateChange = (newDate: Date) => {
        setFromDate(newDate);
    };

    const handleToDateChange = (newDate: Date) => {
        setToDate(newDate);
    };
    return (
        <div className="flex  flex-col md:flex-row gap-4">
            <div className="flex gap-4 items-center ">
                <label htmlFor="" className="font-semibold">
                    From Date:{" "}
                </label>
                <DatePicker
                    dateFormat="dd/MM/yyyy"
                    showIcon
                    selected={fromDate}
                    onChange={(date: any) => handleFromDateChange(date)}
                    className="w-64 rounded-md border border-solid border-slate-950"
                    maxDate={toDate}
                />
            </div>
            <div className="flex gap-4 items-center">
                <label htmlFor="" className="font-semibold">
                    To Date:{" "}
                </label>
                <DatePicker
                    dateFormat="dd/MM/yyyy"
                    showIcon
                    selected={toDate}
                    onChange={(date: any) => handleToDateChange(date)}
                    className="w-64 rounded-md border border-solid border-slate-950"
                    minDate={fromDate}
                />
            </div>
        </div>
    );
}

export default DatePeriodSelection;
